// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import React, {useEffect, useRef} from 'react';

import {useOverlayScrollbars} from 'overlayscrollbars-react';

import {getDefaultOptions} from './getDefaultOptions';

import type {Options} from './getDefaultOptions';
import type {OverlayScrollbars} from 'overlayscrollbars';

export const useScrollWithExternalScrollbars = (option?: Options): {
    ref: React.RefObject<HTMLDivElement>,
    scrollbarsSlotRef: React.RefObject<HTMLDivElement>,
    instance: () => OverlayScrollbars | null,
} => {
    const ref = useRef<HTMLDivElement>(null);
    const scrollbarsSlotRef = useRef<HTMLDivElement>(null);
    const [initialize, instance] = useOverlayScrollbars({
        options: getDefaultOptions(option),
    });
    useEffect(() => {
        if (!ref.current || !scrollbarsSlotRef.current) {
            return;
        }
        initialize({
            target: ref.current,
            scrollbars: {
                slot: scrollbarsSlotRef.current,
            },
        });
        return () => {
            instance()?.destroy();
        };
    }, [instance, initialize]);

    return {
        ref,
        scrollbarsSlotRef,
        instance,
    };
};
